import React from 'react';

import {OEFNWelcomeEntryTypes} from '../../views/flow-nav/welcome/oe-fn-welcome-model';
import OEProtoStartView, {OEProtoStartViewEntryTypes} from '../oe-proto-start-view';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEFlowNavModalFlags} from '../../views/flow-nav/oe-flow-nav-modal';
import {OEFNHelpEntryType} from '../../views/flow-nav/help/oe-flow-nav-help-model';
import {OEEquineHoofTargetType, OEEquineHoofTargets, OEEquineHoofFeatureAccess, OEEquineHoofStartSelectionData} from './oe-equine-hoof-model';

export default class OEEquineHoofStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.entries = [
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: true}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '3.375em' /*54*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEEquineHoofTargetType.anatomy, stringId: 'target_menu_anatomy', icon: OEIconCodes.equineHoof.anatomyTarget},
                {type: OEProtoStartViewEntryTypes.targetType, targetType: OEEquineHoofTargetType.dynamic, stringId: 'target_menu_hoof_dynamic', icon: OEIconCodes.equineHoof.dynamicTarget},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2em' /*32*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/}
            ]},
            {type: OEFNWelcomeEntryTypes.maskBlock, mask: {licenseValid: false}, entries: [
                {type: OEFNWelcomeEntryTypes.spacer, height: '4.625em' /*74*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_text_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEFNWelcomeEntryTypes.licensing},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.25em' /*36*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_module_selection_no_license', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.125em' /*18*/},
                {type: OEProtoStartViewEntryTypes.demo, targetType: OEEquineHoofTargetType.anatomy, stringId: 'target_menu_anatomy', icon: OEIconCodes.equineHoof.anatomyTarget},
                {type: OEFNWelcomeEntryTypes.spacer, height: '2.125em' /*34*/},
                {type: OEFNWelcomeEntryTypes.text, stringId: 'welcome_view_help_target_note', html: true},
                {type: OEFNWelcomeEntryTypes.spacer, height: '1.25em' /*20*/}
            ]},
            {type: OEFNWelcomeEntryTypes.help, stringId: 'welcome_view_help_target_menu', className: 'help-entry', flowNavModalFlags: OEFlowNavModalFlags.closeOnToggle},
            {type: OEFNWelcomeEntryTypes.spacer, height: '1.5em' /*24*/}
        ];
    }

    render()    {

        let targetTypeInfoHelp = [];
        if(OEEquineHoofTargets.targetType(this.props.target) == OEEquineHoofTargetType.anatomy)  targetTypeInfoHelp.push({type: OEFNHelpEntryType.text, stringId: 'info_help_text_hoof_anatomy'});
        if(OEEquineHoofTargets.targetType(this.props.target) == OEEquineHoofTargetType.dynamic)  targetTypeInfoHelp.push({type: OEFNHelpEntryType.text, stringId: 'info_help_text_hoof_dynamic'});
        if(targetTypeInfoHelp.length)   targetTypeInfoHelp.push({type: OEFNHelpEntryType.spacer, height: '1.375em' /*22*/});

        let infoHelp = {
            entries: [
                {type: OEFNHelpEntryType.spacer, height: '3.5em' /*56*/},
                ...targetTypeInfoHelp,
                {type: OEFNHelpEntryType.text, stringId: 'info_help_text'},
                {type: OEFNHelpEntryType.spacer, height: '2.5em' /*40*/},
                {type: OEFNHelpEntryType.usageRights},
                {type: OEFNHelpEntryType.licenseAgreement},
                {type: OEFNHelpEntryType.spacer, height: '2.125em' /*34*/},
                {type: OEFNHelpEntryType.credits},
                {type: OEFNHelpEntryType.feedback},
            ]
        };

        return (
            <OEProtoStartView
                {...this.props}
                entries={this.entries}
                infoHelp={infoHelp}
                versionTargets={OEEquineHoofTargets}
                featureAccess={OEEquineHoofFeatureAccess}
                startSelectionData={OEEquineHoofStartSelectionData}
            />
        );
    }
}